export class UserOverview {
  public UserId: number;
  public FullName: string;
  public UserName: string;
  public Email: string;
  public TeamName: string;
  public Access: string;
  public Disabled: boolean;
  RecordCount: number;
}

export class PendingUserOverview {
  public InviteId: number;
  public UserName: string;
  public Email: string;
  public TeamName: string;
  public Access: string;
}

export class AuthorizedUserAccessType {
  public UserAccessTypeId: number;
  public Name: string;
}

export class JobRole {
  public Id: number;
  public Name: string;
}

export class User {
  public Id: number;
  public UserName: string;
  public Name: string;
  public Email: string;
  public AccessTypeId: number;
  public DealershipId: number;
  public CustomerId: number;
  public DealerGroupId: number;
  public JobsiteId: number;
  public AccessCustomerIds: number[];
  public JobRoles: number[];
  public UndercarriageEnabled: boolean;
  public GetEnabled: boolean;
  public Password: string;
  public StyleId: number;
  public Phone: string;
  public safetyEnabled: boolean;
  public USI: string;
  public LanguageId: number;
  public UCSetupType: number;
  public ShowAlertTab: number;
  public UserInitials: string;
  public SigninMethod: string;
}
export class UserRequestModel {
  public Id: number = 0;
  public UserName: string = "";
  public pageIndex: number = 0;
  public pageSize: number = 50;

}

export class EditUser {
  public Id: number;
  public UserName: string;
  public Name: string;
  public Email: string;
  public AccessTypeId: number;
  public DealershipId: number;
  public CustomerId: number;
  public DealerGroupId: number;
  public JobsiteId: number;
  public AccessCustomerIds: AccessCustomersForUserEdit[];
  public JobRoles: JobRoleForUserEdit[];
  public UndercarriageEnabled: boolean;
  public GetEnabled: boolean;
  public Password: string;
  public Phone: string;
  public safetyEnabled: boolean;
  public USI: string
  public LanguageId: number;
  public UCSetupType: number;
  public UserInitials: string;
  ShowAlertTab: boolean;
  public SigninMethod: string;
}

export class JobRoleForUserEdit {
  public id: number;
  public itemName: string;
}

export class AccessCustomersForUserEdit {
  public id: number;
  public itemName: string;
}

export enum UserAccessType {
  GlobalAdministrator = 1,
  DealershipAdministrator = 2,
  DealershipUser = 3,
  CustomerAdministrator = 4,
  CustomerUser = 5
}

export interface ResetPasswordAdminViewModel {
  Email: string;
  Password: string;
  UserId: string;
}
